import { getMinPrice } from '@shared/lib/money';
import { FlightSeatMapRowFragment, SeatComfort, RowSeatFragment, FlightClass } from '@websky/graphql';
import { ServiceInfo } from '../model/types';

import { getSeatPrice } from './getSeatPrice';

export function getGroupServices(rows: FlightSeatMapRowFragment[]): ServiceInfo[] {
	const seatsByComfortMap = new Map<SeatComfort, RowSeatFragment[]>();
	const seatsByServiceClassMap = new Map<FlightClass, RowSeatFragment[]>();

	rows.forEach(row => {
		row.seats?.forEach(seat => {
			const comfort = seat!.seatService?.comfort;

			if (comfort) {
				seatsByComfortMap.set(comfort, [...(seatsByComfortMap.get(comfort) ?? []), seat!]);
			}
		});
	});

	seatsByComfortMap.forEach(seatsByComfort => {
		seatsByComfort.forEach(seat => {
			const serviceClass = seat.seatService?.serviceClass;

			seatsByServiceClassMap.set(serviceClass!, [...(seatsByServiceClassMap.get(serviceClass!) ?? []), seat]);
		});
	});

	return [...seatsByServiceClassMap.values()].map(seatsByClass => {
		const seatsWithService = seatsByClass.filter(seat => seat.seatServices?.length);
		const seat = seatsByClass[0];

		const rfics = seat?.rfisc ?? '';
		const serviceClass = seat?.seatService?.serviceClass ?? FlightClass.Economy;
		const comfort = seat?.seatService?.comfort ?? SeatComfort.Standard;

		const minPrice = getMinPrice(seatsWithService, seat => {
			return getSeatPrice(seat);
		});

		return {
			rfics,
			comfort,
			serviceClass,
			minPrice
		};
	});
}
